import * as Sentry from '@sentry/react';
import { USER_SESSION_INFO } from '../okta';
import envConfig from '../config/config';

Sentry.init({
  dsn: envConfig.sentry.dsn,
  enabled: envConfig.sentry.enabled,
  environment: envConfig.sentry.environment,
  release: envConfig.sentry.release,
  dist: envConfig.sentry.dist,
  integrations: [Sentry.browserTracingIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // Match the full request URL. A trailing $ would reject every call that has a path.
  tracePropagationTargets: [
    'https://local.devtempus.com:3000',
    'http://localhost:4500',
    /^https:\/\/[^/]*\.(staging|dev|secure|validation)tempus\.com(?::\d+)?\//,
    /^https:\/\/[^/]*\.(alp|bet|val|prd)\.gcp\.tempus\.cloud(?::\d+)?\//,
  ],
});

export class Logger {
  constructor(name) {
    this.name = name;
  }

  info(...args) {
    console.log(...args);
  }

  debug(...args) {
    console.debug(...args);
  }

  warn(...args) {
    console.warn(...args);
  }

  error(error, ...params) {
    console.error(error, ...params);
    const userInfo = window.sessionStorage.getItem(USER_SESSION_INFO);

    const sentryArgs = { tags: { ...params, userInfo, loggerName: this.name } };
    if (typeof error === 'string') {
      Sentry.captureMessage(error, sentryArgs);
    } else {
      Sentry.captureException(error, sentryArgs);
    }
  }
}

const logger = new Logger('default');

window.addEventListener('error', function (event) {
  logger.error(event.error);
});

export default logger;
